import StockTakeCreate from "./stockTakeCreate.container";

export default StockTakeCreate;
